import React from "react";
import SorTable from "../base/SorTable";

export default class DataSelectTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            random: 0,
            tableData: []
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ 
            selected: nextProps.selected, 
            tableData: this.convertDataForTable(nextProps.data) 
        });
    }

    onSelect(evt) {
        let selected = this.props.selected;

        let index = selected.findIndex(function (entity) {
            return parseInt(entity.id, 10) === parseInt(this, 10);
        }.bind(evt.target.value));

        // If exists remove else add
        if (index > -1) {
            selected.splice(index, 1);
        } else {
            selected.push({ id: parseInt(evt.target.value, 10) })
        }

        this.props.onChange(index, selected);
    }

    convertDataForTable(data) {
        return data.map(function (entity) {
            let data = {};

            this.props.tableColumns.forEach(function(element) {
                if(element.name === "select") return;
                data[element.name] = entity[element.name];
            }, this);

            let index = this.props.selected.findIndex(function (item) {
                return item.id === this;
            }.bind(entity.id));

            data.select = (
                <div>
                    <input type="checkbox"
                        defaultValue={entity.id}
                        checked={index > -1 ? true : false}
                        onChange={this.onSelect.bind(this)} />
                </div>
            );

            return data;
            // eslint-disable-next-line
        }.bind(this));

       
    }

    render() {

        return (
            <SorTable columns={this.props.tableColumns} data={this.state.tableData} searchWidth="100%" headers={true} searchBy="name" />
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/DataSelectTable.js